import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isRecurringMaster } from 'owa-calendar-event-capabilities';

export default function getEventKey(
    event: CalendarEvent | Partial<CalendarEvent>,
    forSeriesMaster: boolean
): string {
    return forSeriesMaster || isRecurringMaster(event.CalendarItemType)
        ? event.InstanceKey
        : event.ItemId.Id;
}
